interface MediaItem {
  title: string;
  cover: string;
  tag: string;
  desc: string;
}

const mediaItems: MediaItem[] = [
  {
    title: '2026夏季新番导览特辑',
    cover: "https://readdy.ai/api/search-image?query=Colorful%20anime%20collage%20with%20multiple%20summer-themed%20characters%2C%20bright%20blue%20sky%20and%20ocean%20background%2C%20warm%20coral%20and%20orange%20accents%2C%20Japanese%20anime%20style%2C%20energetic%20summer%20vibe%2C%20clean%20composition%2C%20promotional%20visual&width=800&height=450&seq=media-anime-01&orientation=landscape",
    tag: '新番特辑',
    desc: '一口气看完本季最值得期待的新番，热血、恋爱、奇幻全收录。',
  },
  {
    title: '国漫崛起：2026精品盘点',
    cover: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20animation%20showcase%20with%20traditional%20ink%20painting%20style%20merged%20with%20modern%203D%20rendering%2C%20golden%20and%20jade%20green%20accents%2C%20mythological%20creatures%2C%20cinematic%20lighting%2C%20clean%20composition&width=800&height=450&seq=media-anime-02&orientation=landscape",
    tag: '国漫盘点',
    desc: '从2D到3D，从古风到科幻，国产动漫的惊艳之作一网打尽。',
  },
  {
    title: '韩漫入坑指南：必看TOP20',
    cover: "https://readdy.ai/api/search-image?query=Elegant%20Korean%20webtoon%20style%20illustration%20with%20diverse%20character%20portraits%2C%20soft%20pastel%20peach%20and%20coral%20color%20scheme%2C%20romantic%20and%20dramatic%20atmosphere%2C%20clean%20modern%20aesthetic%2C%20professional%20digital%20illustration&width=800&height=450&seq=media-anime-03&orientation=landscape",
    tag: '韩漫指南',
    desc: '从零开始的韩漫之旅，精选20部高分入坑作品推荐。',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            精彩特辑
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            专题盘点与入坑指南，帮你发现更多好作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden transition-colors hover:bg-background-200/50"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                {/* Play icon overlay */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/80 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-2xl ml-1"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}